/**
 * @file index.js
 * @description Entry point for Home.
 * @module Home
 * @version 0.1.0
 */

import '../../../style/pages/home/index.scss'
import initializeGlobals from '../global/index'
import initializeDatePicker from '../../modules/date'

/**
 * Initialize application
 */
async function initApplication() {
  try {
        await initializeGlobals()
  } catch (error) {
    console.error("Initialization failed:", error);
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initApplication);
} else {
  initApplication();
  initializeDatePicker()
}
